import { coreRoutes } from "./route-manifest-core";
import { workflowRoutes } from "./route-manifest-workflows";
import type { AppRouteDefinition } from "./route-types";

export const routeManifest: AppRouteDefinition[] = [...coreRoutes, ...workflowRoutes];
